import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { ClaimsComponent, LayoutContext } from '@/_shared/components';
import { Roles } from '@/_shared/constants/roles';
import { ProfileRecap, TeamList } from '../components';
import { TeamsDepartment } from '../components/TeamsDepartment';
import { getEmployeesMeCall } from '../state';

export const ProfileScreen = () => {
  const t = useTranslations('profile');
  const { setLayout } = useContext(LayoutContext);

  const { hasManagerLeader, hasTeamLeader } = getEmployeesMeCall.hook();

  useEffect(() => {
    setLayout({ title: 'profile' });
  }, [setLayout, t]);

  return (
    <>
      <ProfileRecap />
      <ClaimsComponent roles={[Roles.Manager]}>
        <Box>
          {hasManagerLeader && <TeamsDepartment />}
          {hasTeamLeader && <TeamList />}
        </Box>
      </ClaimsComponent>
    </>
  );
};
